var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseForm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "close_form",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5992",
    "data-name": "Rectangle 5992",
    width: 36,
    height: 36,
    rx: 4,
    fill: "#e3e5e8",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close_black_24dp",
    transform: "translate(2.308 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47256",
    "data-name": "Path 47256",
    d: "M0,0H32V32H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47257",
    "data-name": "Path 47257",
    d: "M22.6,5.811a1.328,1.328,0,0,0-1.88,0L14.2,12.318,7.678,5.8A1.329,1.329,0,0,0,5.8,7.677l6.52,6.52L5.8,20.718a1.329,1.329,0,0,0,1.88,1.88l6.52-6.52,6.52,6.52a1.329,1.329,0,0,0,1.88-1.88l-6.52-6.52,6.52-6.52A1.336,1.336,0,0,0,22.6,5.811Z",
    transform: "translate(1.802 1.802)",
    fill: "#374955"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseForm);
export default __webpack_public_path__ + "static/media/close_form.7580456c2ab552012fd5aadc98171349.svg";
export { ForwardRef as ReactComponent };